import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const WORDS = [
  "Last-Minute Luxury",
  "Filled Chairs",
  "Zero No-Shows",
  "Book Your Look",
  "On Demand",
  "Instant Openings",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative z-10 border-y border-black/10 bg-[#EDEAE4] py-10 md:py-14"
    >
      <Marquee speed={28} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-serif text-5xl md:text-7xl lg:text-8xl font-light text-black/15">
              {w}
            </span>
            <Star className="h-5 w-5 shrink-0 text-gold" fill="currentColor" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
